import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetStatus,
  clearError,
  selectDeclaracoesAduaneirasStatus,
  selectDeclaracoesAduaneirasError
} from '../../../../features/declaracoesAduaneiras/declaracoesAduaneirasSlice';
import { LOADING_STATUS, FAILURE_STATUS } from '../../../../features/status';
import QCXPageTemplate from '../../../../templates/page/QCXPageTemplate';
import DeclaracoesAduaneirasContext from '../../../../contexts/import/declaracoesAduaneiras/declaracoesAduaneirasContext';

export default function DeclaracoesAduaneirasPage({ children }) {
  const dispatch = useDispatch();
  const status = useSelector(selectDeclaracoesAduaneirasStatus);
  const error = useSelector(selectDeclaracoesAduaneirasError);

  const isLoading = useMemo(() => status === LOADING_STATUS, [status]);

  const [successSnackbar, setSuccessSnackbar] = useState({
    open: false,
    message: '',
  });
  const [errorSnackbar, setErrorSnackbar] = useState({
    open: false,
    message: '',
  });

  const handleOpenErrorSnackbar = useCallback((message) => {
    setErrorSnackbar({ open: true, message });
  }, []);
  const handleCloseSuccessSnackbar = useCallback(() => {
    setSuccessSnackbar((prev) => ({ ...prev, open: false }));
  }, []);
  const handleCloseErrorSnackbar = useCallback(() => {
    setErrorSnackbar((prev) => ({ ...prev, open: false }));
  }, []);

  useEffect(() => {
    if (status === FAILURE_STATUS && error) {
      handleOpenErrorSnackbar(error);
      dispatch(resetStatus());
    }
  }, [status, error, dispatch, handleOpenErrorSnackbar]);

  const providerData = useMemo(
    () => ({
      status,
      isLoading,
      successSnackbar,
      errorSnackbar,
      handleCloseSuccessSnackbar,
      handleCloseErrorSnackbar,
    }),
    [status, isLoading, successSnackbar, errorSnackbar, handleCloseSuccessSnackbar, handleCloseErrorSnackbar]
  );

  return (
    <DeclaracoesAduaneirasContext.Provider value={providerData}>
      <QCXPageTemplate contextComponent={DeclaracoesAduaneirasContext}>
        {children}
      </QCXPageTemplate>
    </DeclaracoesAduaneirasContext.Provider>
  );
}
